import React from 'react';

import Icon from '@ant-design/icons';
import { useDataTransformPanelStore } from '@components/data-transform-panel/store';
import { transformRenameRulesToState } from '@components/data-transform-panel/utils/handleTransformRulesUtils';
import { useDimensionWorkflow, useTopPanelStore } from '@hooks';
import { ERenameTitle, ERenamedDimension } from '@src/common/constant/enum';
import ViewDetailIcon from '@src/icons/emp/view_detial.svg';
import { EFormMode } from '@src/emp-3.0/types/common';
import { useWorkflowStore } from '@src/pages/workflow/store';
import PermissionButton from '@src/emp-3.0/components/PermissionButton';
import { useNavigate } from 'react-router-dom';
interface IProps {
  event: any;
}

const transformTitleMap = {
  [ERenamedDimension.edited_page_title]: ERenameTitle.PAGE,
  [ERenamedDimension.edited_screen_title]: ERenameTitle.SCREEN,
};

const RenameDimensionMenu: React.FC<IProps> = ({ event }) => {
  const navigate = useNavigate();
  const isNewWorkflow = useDimensionWorkflow();
  const { setFormMode } = useWorkflowStore();
  const [
    setTransformTitle,
    setTransformRule,
    setTransformId,
    setTransformName,
    setTransformTargetDimension,
  ] = useDataTransformPanelStore((state) => [
    state.setTransformTitle,
    state.setTransformRule,
    state.setTransformId,
    state.setTransformName,
    state.setTransformTargetDimension,
  ]);
  const { openTransformPanel } = useTopPanelStore();

  const handleEditMappedEvent = (e) => {
    e.stopPropagation();
    if (!event) return;
    if (isNewWorkflow) {
      setFormMode(EFormMode.EDIT);
      navigate(`/workflow/rename/${event.id}/eventLooker`);
      return;
    }
    const transformTitleValue = transformTitleMap[event.target_dimension];
    openTransformPanel();
    transformTitleValue && setTransformTitle(transformTitleValue);
    setTransformName(event.name);
    setTransformId(event.id);
    setTransformTargetDimension(event.target_dimension);
    setTransformRule(transformRenameRulesToState(event.transform_rule));
  };

  return (
    <PermissionButton
      onClick={handleEditMappedEvent}
      disabledStyle={{ color: 'rgba(0, 0, 0, 0.65)' }}
    >
      <Icon
        style={{
          cursor: 'pointer',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
        }}
        component={ViewDetailIcon}
      />
    </PermissionButton>
  );
};

export default RenameDimensionMenu;
